import { useSyncExternalStore } from "react";

let count = 0;
const listeners = new Set<() => void>();

function emit() {
  for (const listener of listeners) listener();
}

export function pushOverlay() {
  count += 1;
  emit();
}

export function popOverlay() {
  count = Math.max(0, count - 1);
  emit();
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** True while any bottom sheet / dialog is open, so chrome can step aside. */
export function useOverlayOpen() {
  return useSyncExternalStore(
    subscribe,
    () => count > 0,
    () => false,
  );
}
